module.exports = __webpack_public_path__ + "static/media/majorF4.eb50128.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorF4.wav
// module id = hnS/
// module chunks = 0